import { render, staticRenderFns } from "./GeneralLedgerReportActivityAll.vue?vue&type=template&id=61ffe249&scoped=true&"
import script from "./GeneralLedgerReportActivityAll.vue?vue&type=script&lang=js&"
export * from "./GeneralLedgerReportActivityAll.vue?vue&type=script&lang=js&"
import style0 from "./GeneralLedgerReportActivityAll.vue?vue&type=style&index=0&id=61ffe249&prod&lang=css&"
import style1 from "./GeneralLedgerReportActivityAll.vue?vue&type=style&index=1&id=61ffe249&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ffe249",
  null
  
)

export default component.exports